import { useCallback, useState, useContext, useEffect } from 'react';
import { ClientStore } from '../../../Store/StoresObjects/ClientStore';
import { removeTrailingSlashes } from '../../../utils/locationUtils';
import { invokeOrRenderChildren } from '../../../utils/reactHelpers';
import { StoreContext } from '../../appContext/StoreProvider';

export const useActiveLink = (onActiveLinkChange) => {
  const [activeLink, setActiveLink] = useState('');
  const { store } = useContext(StoreContext);

  const handleFocusLocationChange = useCallback((nextValue) => {
    if (nextValue) {
      setActiveLink(nextValue);
    }
  }, []);

  const isActive = useCallback(
    (linkToCompare) => {
      return activeLink === linkToCompare;
    },
    [activeLink],
  );

  useEffect(() => {
    // Subscribe To Focus Location on Mount
    const focusLocationSubscription = (store as ClientStore).subscribeToFocusLocation(
      handleFocusLocationChange,
    );

    // UnSubscribe To Focus Location on Unmount
    return () => focusLocationSubscription.unsubscribe();
  }, []);

  useEffect(() => {
    return (
      onActiveLinkChange &&
      onActiveLinkChange(
        `${removeTrailingSlashes(store.storePath)}${activeLink}`,
      )
    );
  }, [activeLink, onActiveLinkChange]);

  return { isActive, activeLink };
};

export const ActiveLink = ({ onActiveLinkChange, children }) => {
  const { isActive, activeLink } = useActiveLink(onActiveLinkChange);
  return invokeOrRenderChildren({
    children,
    callWith: { isActive, activeLink },
  });
};
